<template>
    <v-dialog
        v-model="isOpen"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
    >
        <v-card class="external-link-modal">
            <v-btn
                icon
                class="close-btn"
                @click="close"
            >
                <v-icon>icon-close</v-icon>
            </v-btn>
            <iframe
                v-if="url"
                :src="url"
                class="external-iframe"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            />
        </v-card>
    </v-dialog>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'ExternalLinkModal',
        data: () => ({
            isOpen: false,
            url: null
        }),
        mounted() {
            EventBus.$on('openExternalLink', this.open);
        },
        beforeDestroy() {
            EventBus.$off('openExternalLink', this.open);
        },
        methods: {
            open(url) {
                this.url = url;
                this.isOpen = true;
            },
            close() {
                this.isOpen = false;
                this.url = null;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .external-link-modal {
        position: relative;
        width: 100%;
        height: 100%;
        background: #fff;

        .close-btn {
            position: absolute;
            top: 16px;
            right: 16px;
            z-index: 10;
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

            &:hover {
                background: #fff;
            }
        }

        .external-iframe {
            width: 100%;
            height: 100%;
            border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ExternalLinkModal.vue